import type { DNDInfo } from '@library/library.types';
import type { DNDBlock, GlobalVariablesBlocks } from '@stratumn/studio-shared';
import type { FC } from 'react';

import { GlobalVariable } from './blocks/globalVariableBlock/globalVariable.comp';

export const isGlobalVariablesBlocks = (
  blockType: unknown
): blockType is GlobalVariablesBlocks =>
  (['GlobalVariable'] satisfies GlobalVariablesBlocks[]).includes(
    blockType as GlobalVariablesBlocks
  );

export const GLOBAL_VARIABLES_INFO_DND: DNDInfo = {
  title: 'Global Variables',
  description:
    "Define global variables that will be defined during the workflow's execution."
};

const GlobalVariableBlockPlexer = {
  GlobalVariable
};

type LibraryTraceOverviewProps = {
  block: DNDBlock;
};

export const LibraryGlobalVariable: FC<LibraryTraceOverviewProps> = ({
  block
}) => {
  const Block = GlobalVariableBlockPlexer[block.type as GlobalVariablesBlocks];
  return <Block {...block} />;
};
